import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "oem-config-page" }
const _hoisted_2 = { class: "config-layout" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "preview-text" }
const _hoisted_5 = { class: "upload-section" }
const _hoisted_6 = { class: "upload-box" }
const _hoisted_7 = {
  key: 0,
  class: "upload-placeholder"
}
const _hoisted_8 = ["src"]

import { reactive } from 'vue'
import { message } from 'ant-design-vue'
import { UploadOutlined } from '@ant-design/icons-vue'
import SystemSideMenu from '@/components/SystemSideMenu.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'OemConfig',
  setup(__props) {

const formState = reactive({
  adminCenterFile: '',
  recordText: '',
  recordPrefix: '粤',
  recordNumber: '',
  icpNumber: '',
  logo: '',
  accessUrl: 'http://127.0.0.1:7777/app/omvib/thematicode=default'
})

const copyUrl = () => {
  navigator.clipboard.writeText(formState.accessUrl)
  message.success('复制成功')
}

const handleSubmit = () => {
  // 处理表单提交逻辑
  console.log('表单数据：', formState)
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { bordered: false }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "page-title" }, "OEM配置", -1)),
            _createVNode(_component_a_form, {
              "label-col": { span: 4 },
              "wrapper-col": { span: 16 }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, { label: "管理中心文件组" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: formState.adminCenterFile,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.adminCenterFile) = $event)),
                      placeholder: "请输入管理中心文件组名称"
                    }, null, 8, ["value"]),
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "upload-hint" }, "请输入管理中心文件组名", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "备案文字预览" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: formState.recordText,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.recordText) = $event)),
                      placeholder: "请输入备案文字"
                    }, null, 8, ["value"]),
                    _createElementVNode("div", _hoisted_4, "生成结果：" + _toDisplayString(formState.recordText || 'XXX版权所有© XXX'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "公安备案号" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_group, { compact: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: formState.recordPrefix,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formState.recordPrefix) = $event)),
                          style: {"width":"80px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: "粤" }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode("粤")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"]),
                        _createVNode(_component_a_input, {
                          value: formState.recordNumber,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formState.recordNumber) = $event)),
                          style: {"width":"calc(100% - 80px)"},
                          placeholder: "备案号"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "ICP备案号" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: formState.icpNumber,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formState.icpNumber) = $event)),
                      placeholder: "示例：粤ICP备xxxxxx号"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "图标上传" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        (!formState.logo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createVNode(_unref(UploadOutlined)),
                              _cache[8] || (_cache[8] = _createElementVNode("span", null, "上传", -1))
                            ]))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: formState.logo,
                              alt: "logo"
                            }, null, 8, _hoisted_8))
                      ]),
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "upload-text" }, "LOGO上传", -1))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "用户访问地址" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: formState.accessUrl,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formState.accessUrl) = $event)),
                      placeholder: "http://127.0.0.1:7777/app/omvib/thematicode=default"
                    }, null, 8, ["value"]),
                    _createVNode(_component_a_button, {
                      type: "link",
                      class: "copy-btn",
                      onClick: copyUrl
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("复制链接")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { "wrapper-col": { offset: 4 } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: handleSubmit
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode("确认保存")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})